export default {
  open: false
};
